import React from 'react';
import { motion } from 'framer-motion';
export function OpeningTestimonials() {
  const testimonials = [{
    initials: 'LM',
    quote: 'Tenía Biomecánica y Evaluación Kinésica en 3 semanas y no sabía por dónde empezar. El Rescate Académico tiene todo organizado por región, con los tests y protocolos paso a paso. Aprobé con 9.',
    author: 'Lucía M., Córdoba · 3° año Kinesiología UNC'
  }, {
    initials: 'FS',
    quote: 'Lo que más me sirvió fue el Bonus de Supervivencia Hospitalaria. Llegué a la rotación sabiendo cómo leer los signos vitales y manejarme en la UTI sin que me agarrara el pánico frente al paciente.',
    author: 'Franco S., Buenos Aires · 4° año Kinesiología UBA'
  }, {
    initials: 'VP',
    quote: 'Antes juntaba apuntes de 10 compañeros y nada coincidía. El Rescate tiene todo en un solo lugar, con el lenguaje exacto que piden en los exámenes. Ya aprobé 4 materias con él.',
    author: 'Valentina P., Rosario · 3° año Kinesiología UNR'
  }];
  return <section className="w-full bg-slate-50 py-12 md:py-16 px-4" data-id="element-253">
      <div className="max-w-6xl mx-auto" data-id="element-254">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-255">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-white p-6 rounded-lg shadow-md border border-slate-200" data-id="element-256">
              <div className="flex items-center gap-3 mb-4" data-id="element-257">
                <div className="w-12 h-12 bg-slate-200 rounded-full flex items-center justify-center font-bold text-slate-700" data-id="element-258">
                  {testimonial.initials}
                </div>
                <div className="text-yellow-500 text-lg" data-id="element-259">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-slate-700 mb-4 leading-relaxed" data-id="element-260">
                "{testimonial.quote}"
              </p>
              <p className="text-sm text-slate-500 font-medium" data-id="element-261">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}